var vueModel = function (){
  return  new Vue({
    el: '#popup-container',
    data:{
        'tipus': '',
        'nom': '',
        'descripcio': '',
        'comarca': '',
        'poblacio': '',
        'tipus_via': '',
        'nom_carrer': '',
        'numero': '',
        'pis_porta': '',
        'codi_postal': '',
        'web': '',
        'adreca1': '',
        'adreca2': ''
    },
    methods:{
      makeActive:function(centre){
        this.tipus = (centre.tipus===null)?'':centre.tipus,
        this.nom = (centre.nom===null)?'':centre.nom,
        this.descripcio = (centre.descripcio===null)?'':centre.descripcio,
        this.comarca = (centre.comarca===null)?'':centre.comarca,
        this.poblacio = (centre.poblacio===null)?'':centre.poblacio,
        this.tipus_via = (centre.tipus_via===null)?'':centre.tipus_via,
        this.nom_carrer = (centre.nom_carrer===null)?'':centre.nom_carrer,
        this.numero = (centre.numero===null)?'':centre.numero,
        this.pis_porta = (centre.pis_porta===null)?'':centre.pis_porta,
        this.codi_postal = (centre.codi_postal===null)?'':centre.codi_postal,
        this.web = (centre.web===null)?'':( (centre.web.toLowerCase().indexOf('www')===0)?'http://'+centre.web: centre.web),
        this.adreca1 = this.tipus_via +' ' +this.nom_carrer+', '+this.numero,
        this.adreca2 = this.codi_postal+' '+this.poblacio+', '+this.comarca
      }
    }
  })
}

export default vueModel;
